module.exports = {
  context: {
    heading: 'Together we ignite possibility',
    subheading: null,
    image: {
      src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1440x741_crop_center-center_100_none/surfer.jpg?mtime=20210528130813&focal=none&tmtime=20210611150755',
      alt: 'Surfer with surfboard',
      srcSet: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_500x292_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140911 500w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_700x409_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140912 700w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_900x525_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140913 900w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914 1200w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1600x934_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140916 1600w'
    },
    button: {
      text: 'Join Us',
      url: 'https://google.com',
      class: 'primary'
    }
  },
  variants: [
    {
      name: 'Homepage with Video',
      context: {
        heading: 'Together we ignite possibility',
        subheading: null,
        video: {
          url: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/rain.mp4'
        },
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_1440x741_crop_center-center_100_none/surfer.jpg?mtime=20210528130813&focal=none&tmtime=20210611150755',
          alt: 'Surfer with surfboard',
          srcSet: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/_500x292_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140911 500w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_700x409_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140912 700w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_900x525_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140913 900w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1200x700_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140914 1200w, https://d2qzg5sxlz4vb2.cloudfront.net/media/_1600x934_crop_center-center_none/surfer.jpg?mtime=20210528130816&focal=none&tmtime=20210625140916 1600w'
        },
        button: {
          text: 'Join Us',
          url: 'https://google.com',
          class: 'primary'
        }
      }
    }
  ]
}
